/***所有不需要授权的接口**/
import request from '@/utils/request'
import qs from 'qs'
export function getAllKind() {
  return request({
    url: 'cus/getAllKind',
    method: 'get'
  })
}


export function getSystemData() {
  return request({
    url: 'cus/getSystemConfig',
    method: 'get'
  })
}

export function queryYumiOrder(params) {
	// page: 0
	// size: 10
	// sort: createDateTime,desc
	// orderName: a
  return request({
    url: 'cus/yumiOrder'+'?' + qs.stringify(params, { indices: false }),
    method: 'GET'
  })
}
export function searchOrder(params) {
	console.log('[search_params]',params);
	// page: 0
	// size: 10
	// sort: createDateTime,desc
	// orderName: a
  return request({
    url: 'cus/yumiSearchOrder'+'?' + qs.stringify(params, { indices: false }),
    method: 'GET'
  })
}
export function queryTopFwlxYumiOrder(params){
	
	return request({
	  url: 'cus/yumiTopFwlxOrder'+'?' + qs.stringify(params, { indices: false }),
	  method: 'GET'
	})
	
}

export function queryPerformanceFeesByTime(params){
	
	return request({
	  url: 'api/queryPerformanceFeesByTime'+'?' + qs.stringify(params, { indices: false }),
	  method: 'GET'
	})
	
	
}